import { getApiConstants } from '../utils/apiConstants';

export const langConstants = {
    LOAD: getApiConstants('LOAD_TRANSLATIONS'),
    LANG_LOCAL_STORAGE_KEY: 'taxReturnApp.language',
    DEFAULT_LANGUAGE: 'en',
};

export default langConstants;